import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";

export default {
  getMapIntegrations() {
    return apiService.get(endpoints.mapsIntegration);
  },
  toggleMapIntegration(payload) {
    return apiService.patch(endpoints.mapsIntegration, payload);
  }
};
